<template>
  <button
    :class="[
      'scrolling-top-button',
      { 'scrolling-top-button--light': isFestivalYear },
    ]"
    :style="`bottom:${this.bottom}px;right:${this.right}px;`"
    v-show="visible"
    @click="scrollToTop"
    @keypress="scrollToTop"
    title="回到頂端"
    >頂端</button
  >
</template>

<script>
export default {
  name: 'ButtonScrollToTop',
  props: {
    // 捲軸滑到多少會出現
    visibleoffset: {
      type: [String, Number],
      default: 600,
    },
    // 捲軸滑到底部會消失的距離
    visibleoffsetbottom: {
      type: [String, Number],
      default: 0,
    },
    right: {
      type: String,
      default: '24px',
    },
    bottom: {
      type: String,
      default: '45px',
    },
    scrollFn: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    window.smoothscroll = () => {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener('scroll', this.catchScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.catchScroll);
  },
  computed: {
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
  },
  methods: {
    catchScroll() {
      const pastTopOffset = window.pageYOffset > parseInt(this.visibleoffset);
      const pastBottomOffset =
        window.innerHeight + window.pageYOffset >=
        document.body.offsetHeight - parseInt(this.visibleoffsetbottom);
      this.visible =
        parseInt(this.visibleoffsetbottom) > 0
          ? pastTopOffset && !pastBottomOffset
          : pastTopOffset;
      this.scrollFn(this);
    },
    scrollToTop() {
      window.smoothscroll();
      this.$emit('scrolled');
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.scrolling-top-button {
  position: fixed;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background-color: $color-scrolling-button-bg;
  color: $color-scrolling-button-text;
  border: 0;
  box-shadow: 0 0 0 5px $color-scrolling-button-bg;
  text-align: center;
  padding-top: 12px;
  opacity: 0.95;
  font-size: 0.875rem;
  cursor: pointer;
  letter-spacing: 0.83px;

  &:hover,
  &:focus {
    opacity: 1;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 13px;
    width: 17px;
    height: 4px;
    border-radius: 10px;
    background-color: $color-scrolling-button-text;
  }
  &::before {
    left: 18.5px;
    transform: rotate(-45deg);
  }
  &::after {
    right: 18.5px;
    transform: rotate(45deg);
  }

  &--light {
    background-color: $color-light-scrolling-button-bg;
    color: $color-light-bg;
    border: none;
    box-shadow: 0 0 0 5px $color-light-scrolling-button-bg;
    font-weight: 600;

    &::before,
    &::after {
      background-color: $color-light-bg;
    }
  }
}
</style>
